import { ENV } from './types';

const ACORE_DOMAIN: string = '//yx.jd.com';

const TREND_DOMAIN: string = '//yx.jd.com';

const HD_API_DOMAIN: string = '//actcenter.jd.com';

const HD_API_TOOL_DOMAIN: string = '//asta.jd.com';

// 生产http会重定向到https所以改成https
const MC_DOMAIN: string = 'https://mc.jd.com';

const ACE_DOMAIN: string = 'https://ace.jd.com';

const ACE_API_DOMAIN: string = 'https://material.jd.com';

const BABEL_DOMAIN: string = 'https://babel.m.jd.com';

const LINGLONG_DOMAIN: string = 'https://ling.jd.com';

const BABELPRO_DOMAIN: string = 'https://pro.m.jd.com';

const BABELPRO_PC_DOMAIN: string = 'https://pro.jd.com';

const BABELPRO_PARAMS: string = '';

const CELUE_DOMAIN = '//smartmind.jd.com';

const QYPT_DOMAIN = 'https://qypt.jd.com';

const DATA_CENTER_DOMAIN = '//markingcenter.jd.com';
const EASYBI_DOMAIN = '//easybi.jd.com';
const EASYBI_URL_DOMAIN = 'https://easybi.jd.com';

const WAREOPS_DOMAIN = '//ioc.jd.com';

const BAICHUAN_DOMAIN = '//bcms.jd.com/0/welcome';
const SECKILLCMS_DOMAIN = '//seckillcmsyx.jd.com';
const DRIPWORKS_DOMAIN = '//dripworks-yx-pro.pf.jd.com';

const NEWPROCESS = '//dripworks-111-pro.pf.jd.com';

const NEWZHENDI = '//yx.jd.com/platform-marketing/CA040611033766380094';

// 黄金流程数字化服务平台【我京cms配置】
const WEJDPlat_DOMAIN: string = 'http://plat.jd.com';

// 频道标签平台
const EASYLABELPLAT_DOMAIN: string = 'https://easylabel-pb.jd.com';
// 三超CMS【京东三超】
const CICADA_DOMAIN: string = 'https://cicada-pro.pf.jd.com';

const value: ENV = {
  ACORE_DOMAIN,
  TREND_DOMAIN,
  HD_API_DOMAIN,
  DATA_CENTER_DOMAIN,
  EASYBI_DOMAIN,
  EASYBI_URL_DOMAIN,
  MC_DOMAIN,
  ACE_DOMAIN,
  ACE_API_DOMAIN,
  BABEL_DOMAIN,
  LINGLONG_DOMAIN,
  BABELPRO_DOMAIN,
  BABELPRO_PARAMS,
  BABELPRO_PC_DOMAIN,
  CELUE_DOMAIN,
  QYPT_DOMAIN,
  WAREOPS_DOMAIN,
  BAICHUAN_DOMAIN,
  SECKILLCMS_DOMAIN,
  DRIPWORKS_DOMAIN,
  NEWPROCESS,
  NEWZHENDI,
  WEJDPlat_DOMAIN,
  EASYLABELPLAT_DOMAIN,
  CICADA_DOMAIN,
  HD_API_TOOL_DOMAIN,
};

export default value;
